import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { mediaUrl, triggerDownload } from "@/lib/galleryApi";

// Large downloads are split into several ZIP parts (each under the transfer time limit)
export function ZipPartsDialog({ zip, onClose, light }) {
  return (
    <Dialog open={!!zip} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className={light ? "bg-white text-black" : "bg-[#0B1120] border-[#1A2332] text-white"} data-testid="zip-parts-dialog">
        <DialogHeader>
          <DialogTitle>Telechargement en {zip?.parts.length} parties</DialogTitle>
          <DialogDescription className={light ? "text-black/60" : "text-[#94A3B8]"}>{zip?.count} photos — l'archive est decoupee pour un telechargement fiable. Telechargez chaque partie.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {zip?.parts.map((p) => (
            <Button key={p.part} onClick={() => triggerDownload(mediaUrl(p.url))} className="w-full justify-between h-11 bg-[#0099CC] hover:bg-[#0088B5] text-white" data-testid={`zip-part-${p.part}`}>
              <span>Partie {p.part} — {p.count} photos</span><Download className="w-4 h-4" />
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
